(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initGallery();
    initVariantPicker();
    initTabs();
    initFAQ();
  }

  /* ── Image Gallery ── */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var thumbs = gallery.querySelectorAll('[data-thumb-index]');
    var mainImg = gallery.querySelector('[data-main-img]');
    if (!mainImg || !thumbs.length) return;

    var productJson = document.querySelector('[data-product-json]');
    var product = productJson ? JSON.parse(productJson.textContent) : null;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        if (product && product.media) {
          var images = product.media.filter(function (m) { return m.media_type === 'image'; });
          if (images[index]) {
            mainImg.style.opacity = '0';
            setTimeout(function () {
              mainImg.src = images[index].src.replace(/(\?.*)?$/, '') + '?width=1200';
              mainImg.alt = images[index].alt || '';
              mainImg.style.opacity = '1';
            }, 150);
          }
        } else {
          var thumbImg = thumb.querySelector('img');
          if (thumbImg) {
            mainImg.src = thumbImg.src.replace('width=144', 'width=1200');
          }
        }
      });
    });
  }

  /* ── Variant Picker ── */
  function initVariantPicker() {
    var form = document.querySelector('.harrington-form');
    if (!form) return;

    var productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    var product = JSON.parse(productJson.textContent);
    var variantInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var selectedOptions = {};

    product.options.forEach(function (opt, i) {
      var select = form.querySelector('[data-option-select="' + (i + 1) + '"]');
      if (select) selectedOptions[i] = select.value;
    });

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      variantInput.value = variant.id;

      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-default-text') || addBtn.textContent;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }

      if (variant.featured_image) {
        var mainImg = document.querySelector('[data-main-img]');
        if (mainImg) {
          mainImg.src = variant.featured_image.src.replace(/(\?.*)?$/, '') + '?width=1200';
        }
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
      }
      return (cents / 100).toFixed(2);
    }

    if (addBtn) {
      addBtn.setAttribute('data-default-text', addBtn.textContent.trim());
    }

    form.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var position = parseInt(btn.getAttribute('data-option-position'), 10);
        var value = btn.getAttribute('data-option-value');
        selectedOptions[position - 1] = value;

        var select = form.querySelector('[data-option-select="' + position + '"]');
        if (select) select.value = value;

        var picker = btn.closest('[data-option-picker]');
        if (picker) {
          picker.querySelectorAll('[data-option-value]').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');

          var label = picker.querySelector('[data-selected-option="' + position + '"]');
          if (label) label.textContent = value;
        }

        var variant = findVariant();
        if (variant) updateUI(variant);
      });
    });
  }

  /* ── Tabs ── */
  function initTabs() {
    var container = document.querySelector('[data-tabs]');
    if (!container) return;

    var btns = container.querySelectorAll('[data-tab-btn]');
    var panels = container.querySelectorAll('[data-tab-panel]');

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-tab-btn');

        btns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = container.querySelector('[data-tab-panel="' + index + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* ── FAQ Accordion ── */
  function initFAQ() {
    var items = document.querySelectorAll('[data-faq-toggle]');
    if (!items.length) return;

    items.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.harrington-faq__item');
        var isOpen = item.classList.contains('is-open');

        document.querySelectorAll('.harrington-faq__item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
})();
